<template>
  <div class="container" v-if="!loading">
    <img :src="bonusInfo.b_logo" class="b_logo" />
    <span class="title">{{ bonusInfo.title }}</span>
    <span
      class="detail"
      v-for="(s, index) in bonusInfo.aLongDesc"
      :key="index"
      >{{ s }}</span
    >
    <button class="btn" @click="takeBonus">{{ bonusInfo.btn }}</button>
  </div>
</template>
<style scoped lang="less" src="@/styles/bonus.less"></style>
<script>
import Avalon from '@/utils/Avalon';
import mockData from '@/mockData';
import { isDebug } from '@/config';
import NativeApi from "@/utils/nativeApi";
let napiCient = (window.napiCient = new NativeApi());
export default {
  name: "bonus",
  data () {
    return {
      loading: true,
      bonusInfo: {
        b_logo: "",
        title: "",
        detail: "",
        btn: "",
        coupon_link: "",
        aLongDesc: []//长链接
      },
      checked: false,
      trackMap: {
        isVip: 36915,//福利券详情页点击领取时是会员 ，字符串统计点，上报券的名字
        notVip: 36916//福利券详情页点击领取时是普通用户 ，字符串统计点，上报券的名字
      }
    };
  },
  mounted () {
    this.loading = true;
    this.firstload = true;
    console.log('bonus mounted');
    let storageId = sessionStorage.getItem("mid");
    console.log('storageId:', storageId);
    let { mid } = this.$route.params;
    this.mid = mid || storageId;
    console.log('this.mid:', this.mid);
    if (!this.mid) {
      return this.$router.replace('/');
    }
    console.log('this.$route:', this.$route);
    this.init(this.mid);
  },
  activated () {
    document.title = "福利领取";
    console.log('bonus activated');
    if (this.firstload) {
      this.firstload = false;
      return;
    }
    this.loading = true;
    console.log('this.mid:', this.mid);
    let { mid } = this.$route.params;
    this.mid = mid || this.mid;
    if (!this.mid) {
      return this.$router.replace('/');
    }
    console.log('this.$route:', this.$route);
    this.init(this.mid);
  },
  methods: {
    init (id) {
      if (isDebug) {
        this.bonusInfo = Object.assign(this.bonusInfo, mockData.bonus);
        this.loading = false;
        let detail = mockData.bonus.detail;
        this.bonusInfo.aLongDesc = detail && detail.includes('^')
          ? detail.split('^')
          : [detail || ""];
        console.log('debug bonusInfo:', this.bonusInfo);
        return;
      }
      Avalon.getBonus(id).then(bonus => {
        console.log('bonus:', bonus);
        this.bonusInfo = Object.assign(this.bonusInfo, bonus);
        //换行拆分
        let detail = bonus.detail;
        this.bonusInfo.aLongDesc = detail && detail.includes('^')
          ? detail.split('^')
          : [detail || ""];
        this.loading = false;
        this.hideLoading();
      }).catch(e => {
        console.log(e);
        this.hideLoading();
        this.loading = false;
        this.showToast({ title: "当前无可用福利～" });
      });
    },
    takeBonus () {
      if (this.click) {
        return;
      }
      this.click = true;
      console.log('this.bonusInfo.coupon_link:', this.bonusInfo.coupon_link);
      console.log('isVip:', sessionStorage.getItem("isVip"));
      if (this.globalData.isVip || sessionStorage.getItem("isVip") == 1) {
        console.log('this.click:', this.click);
        sessionStorage.setItem("mid", this.mid);
        location.href = this.bonusInfo.coupon_link;
        setTimeout(() => {
          this.click = false;
        }, 1500);
        napiCient.doStringEmid(this.trackMap["isVip"], this.bonusInfo.title);
      } else {
        napiCient.doStringEmid(this.trackMap["notVip"], this.bonusInfo.title);
        this.showToast({ title: "立即开通会员即可享受福利" });
        setTimeout(() => {
          this.$router.replace({ name: "Vip" });
        }, 1500);
      }
    }
  },
}
</script>